import * as React from 'react';
import PropTypes from "prop-types";
import { Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

function ConfirmationDialog({
    // confirmDialogStatus,
    title,
    btnText,
    content,
    confirmAction,
    pendingDelete,
    LoadingButtonProps,
    color = "error",
    children,
    ...props
}) {
    const { t } = useTranslation()
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = (event) => {
        event.stopPropagation()
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <LoadingButton
                color={color}
                variant="contained"
                disableElevation
                onClick={handleClickOpen}
                loading={pendingDelete}
                {...LoadingButtonProps}
                {...props}
            >
                {btnText ? btnText : children}
            </LoadingButton>

            <Dialog
                open={open}
                onClose={(e) => e.preventDefault()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{ textTransform: "none", }}
                        variant='contained'
                        onClick={handleClose}>
                        {t("Close")}
                    </Button>
                    {!!confirmAction &&
                        <Button
                            sx={{ textTransform: "none", mx: '4px' }}
                            variant='contained'
                            onClick={() => {
                                confirmAction()
                                handleClose()
                            }} autoFocus>
                            {t("Confirm")}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </>
    );
}

export default ConfirmationDialog;